import { useEffect, useState, type ReactNode } from 'react';

import { SESSION_EXPIRED_EVENT } from '../api/client.ts';
import { usePlatform } from '../platform/index.ts';

// Listens for the api-client's session-expired event and renders a
// blocking overlay until the user closes the miniapp. Closing forces
// Telegram to re-mint initData on next open; there is no soft "refresh
// session" path — the WebApp surface gets a single auth_date at launch.
export const SessionExpiredOverlay = (): ReactNode => {
  const platform = usePlatform();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onExpired = (): void => {
      setOpen(true);
    };
    window.addEventListener(SESSION_EXPIRED_EVENT, onExpired);
    return (): void => {
      window.removeEventListener(SESSION_EXPIRED_EVENT, onExpired);
    };
  }, []);

  if (!open) return null;

  return (
    <div
      className="session-expired-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="session-expired-title"
    >
      <div className="session-expired-card">
        <h2 id="session-expired-title">Session expired</h2>
        <p>Reopen the miniapp from your chat to start a new session.</p>
        <button
          type="button"
          className="btn-primary"
          onClick={(): void => {
            platform.close();
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
};
